export const config = {
  local: {
    apiKey: "AIzaSyAS97JQrrzLSATXSt3n8vQ33d-Jsfqeytg",
    authDomain: "public-alert-cloud.firebaseapp.com",
    databaseURL: "https://public-alert-cloud.firebaseio.com",
    projectId: "public-alert-cloud",
    storageBucket: "public-alert-cloud.appspot.com",
    messagingSenderId: "1082662022106",
    appId: "1:1082662022106:web:76a1648eaa9a2e9756eee3",
    measurementId: "G-QP2EXVN3ZN"
  },
  stage: {

  }, 
  prod: {
    apiKey: "AIzaSyC0GulA69sHlSngEb5BnABQwB-990GyKVM",
    authDomain: "public-alert-prod.firebaseapp.com",
    databaseURL: "https://public-alert-prod.firebaseio.com",
    projectId: "public-alert-prod",
    storageBucket: "public-alert-prod.appspot.com",
    messagingSenderId: "622005374715",
    appId: "1:622005374715:web:85d64fa5b634b6bdeaea5e",
    measurementId: "G-3R7DMEHFT3"
  }
}